import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../unsorted/index4.js';
import { _ as _slicedToArray } from '../../unsorted/slicedToArray.js';
import { _ as _defineProperty } from '../../unsorted/defineProperty.js';
import { _ as _objectWithoutProperties } from '../../unsorted/objectWithoutProperties.js';
import { useContext, useState, useRef, useMemo, useEffect } from 'react';
import { m as merge } from '../../unsorted/index.js';
import { T as TooltipComponentContext } from '../shared/shared2.js';
import { usePrevious } from '../../hooks/usePrevious.js';
import { useUpdateEffect } from '../../hooks/useUpdateEffect.js';
import { _ as _taggedTemplateLiteral } from '../../unsorted/taggedTemplateLiteral.js';
import { keyframes } from '@emotion/react';
import { setCacheItem, getCacheItem } from '../../utils/cacheHelpers.js';
import { warnUser } from '../../utils/componentHelpers.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../../hooks/useTheme.js';
import { S as SvgIcon } from '../SvgIcon/SvgIcon.js';

var _templateObject;
var dualVariantIcons = ["Add", "Alert", "AirDrop", "ArrowDown", "ArrowUp", "ArrowBackward", "ArrowForward", "Authenticated", "Calendar", "Cart", "Craft", "Circle", "ChevronBackward", "ChevronCollapse", "ChevronExpand", "ChevronForward", "CircleRightArrow", "CircleDownArrow", "Close", "CloseWithCircle", "Coins", "CopyText", "Countdown", "Dashboard", "Delete", "DevContracts", "DevExplorer", "Document", "Documents", "Dollar", "Education", "Edit", "EmailAddress", "EmbedCode", "ESports", "EthToken", "Exclamation", "Experiment", "Expand", "Faucet", "Fullscreen", "FullscreenExit", "Groups", "Home", "HidePassword", "ImageAdd", "Immutable", "ImxRewards", "ImxToken", "Information", "InformationCircle", "Instagram", "JumpTo", "Logout", "Lock", "Menu", "Minting", "Minus", "More", "MoreVertical", "Notification", "NotificationBell", "PancakeSwap", "People", "PeopleNone", "ReturnKeyboard", "Sandbox", "Search", "Send", "Security", "SettingsCog", "Shield", "StarFull", "StarHalf", "SupportChat", "ShowPassword", "SocialShare", "SoundOn", "SoundOff", "Sparkle", "Swatch", "Tagging", "TickWithCircle", "Tags", "ThemeDark", "ThemeLight", "Tick", "Tokens", "TreasureChest", "TreeDiagram", "Trophy", "ViewList", "Wallet", "Profile", "Items", "BankCard", "X", "PlayGame", "NotificationBellActive", "HeartEffort", "Layer3"];
var singleVariantIcons = ["Apple", "ApplicationWeb", "ApplicationMobile", "Automation", "DevSdk", "Discord", "Email", "Exchange", "Filter", "GitHub", "GraphPerformance", "Google", "Import", "JumpTo", "Language", "LinkedIn", "Loading", "Pause", "Percentage", "Planet", "Play", "Preferences", "Question", "Reddit", "Refresh", "Sort", "SushiSwap", "Swap", "Flip", "Sword", "Telegram", "Twitter", "UniSwap", "Unity", "UnfoldMore", "UnfoldLess", "ViewGrid", "WalletConnect", "WalletDisconnect", "Webhooks", "YouTube", "Overview"];
var allIcons = [].concat(dualVariantIcons, singleVariantIcons);
function jsonHasBoldVariant(json) {
  return "bold" in json;
}
function fetchIconContent(_x, _x2) {
  return _fetchIconContent.apply(this, arguments);
}
function _fetchIconContent() {
  _fetchIconContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(icon, variant) {
    var localStorageKey, cachedIcon, isBoldVariant, resp, children, content, errorMessage;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          localStorageKey = "icon-".concat(icon, "-").concat(variant);
          _context.next = 3;
          return getCacheItem(localStorageKey);
        case 3:
          cachedIcon = _context.sent;
          isBoldVariant = variant === "bold";
          if (!cachedIcon) {
            _context.next = 7;
            break;
          }
          return _context.abrupt("return", cachedIcon);
        case 7:
          _context.prev = 7;
          _context.next = 10;
          return fetch("https://biome.immutable.com/hosted-assets/icons/".concat(icon, ".json"));
        case 10:
          resp = _context.sent;
          _context.next = 13;
          return resp.json();
        case 13:
          children = _context.sent;
          if (isBoldVariant && !jsonHasBoldVariant(children)) {
            warnUser("<Icon /> warning - Bold variant is requested, but the SVG paths data was not found for icon: ".concat(icon, "."));
          }
          content = isBoldVariant && jsonHasBoldVariant(children) ? children.bold : children.regular;
          setCacheItem(localStorageKey, content);
          return _context.abrupt("return", content);
        case 20:
          _context.prev = 20;
          _context.t0 = _context["catch"](7);
          errorMessage = _context.t0 instanceof Error ? _context.t0.message : "Unknown error";
          console.error("🧬 BIOME (icon) Error 🚨:", errorMessage);
          return _context.abrupt("return", null);
        case 25:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[7, 20]]);
  }));
  return _fetchIconContent.apply(this, arguments);
}
var spinIconKeyframes = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from { \n    rotate: 0deg; \n  } \n  to { \n    rotate: 360deg; \n  }\n"])));

var _excluded = ["icon", "sx", "testId", "className"],
  _excluded2 = ["variant"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Icon(_ref) {
  var _svgContent$join;
  var icon = _ref.icon,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    testId = _ref.testId,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var _ref2 = "variant" in props ? props : _objectSpread(_objectSpread({}, props), {}, {
      variant: undefined
    }),
    variant = _ref2.variant,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  var _useTheme = useTheme(),
    globalConfig = _useTheme.globalConfig;
  var _useContext = useContext(TooltipComponentContext),
    triggerDomRecrawl = _useContext.triggerDomRecrawl;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    svgContent = _useState2[0],
    setSvgContent = _useState2[1];
  var previousVariant = usePrevious(variant);
  var isFetching = useRef(false);
  var previousIcon = usePrevious(icon);
  var mergedSx = useMemo(function () {
    return icon === "Loading" ? merge({
      animation: "".concat(spinIconKeyframes, " ").concat((globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.motionProfile) === "fast" ? "0.6s" : "1.2s", " linear infinite"),
      transformOrigin: "50% 50%"
    }, sx) : sx;
  }, [icon, globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.motionProfile, sx]);
  useEffect(function () {
    function fetchContent() {
      return _fetchContent.apply(this, arguments);
    } // @NOTE: ONLY fetch the icon content if it hasn't already
    // been fetched and when the variant changes
    function _fetchContent() {
      _fetchContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var content;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isFetching.current = true;
              _context.next = 3;
              return fetchIconContent(icon, variant);
            case 3:
              content = _context.sent;
              if (content) setSvgContent(content);
              isFetching.current = false;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _fetchContent.apply(this, arguments);
    }
    if (!isFetching.current && (!svgContent || previousVariant !== variant)) {
      fetchContent();
    }
  }, [icon, variant, svgContent, previousVariant]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(function () {
    triggerDomRecrawl === null || triggerDomRecrawl === void 0 ? void 0 : triggerDomRecrawl();
  }, [triggerDomRecrawl, svgContent]);
  useUpdateEffect(function () {
    if (previousIcon !== icon) setSvgContent(null);
  }, [icon, previousIcon]);
  return jsx(SvgIcon, _objectSpread(_objectSpread({}, otherProps), {}, {
    testId: testId,
    sx: mergedSx,
    "data-icon": icon,
    "data-variant": variant && dualVariantIcons.includes(icon) ? variant : "regular",
    className: "".concat(className !== null && className !== void 0 ? className : "", " Icon"),
    children: svgContent && jsx("g", {
      "data-testid": "".concat(testId, "__g")
      // biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
      ,
      dangerouslySetInnerHTML: {
        __html: svgContent === null || svgContent === void 0 || (_svgContent$join = svgContent.join) === null || _svgContent$join === void 0 ? void 0 : _svgContent$join.call(svgContent, "")
      }
    })
  }));
}
Icon.displayName = "Icon";

export { Icon as I, allIcons as a, dualVariantIcons as d, singleVariantIcons as s };
//# sourceMappingURL=Icon.js.map
